<template>
<div class="mc-question">
  <div>
    <img v-if="node.question.image !== null" :src="node.question.image" class="question-image" />
    <p v-if="node.prompt !== null">{{node.prompt}}</p>
    <div v-html="node.question.instructions"></div>
    <div v-if="node.question.hotspot_svg === null">
      <v-radio-group v-model="selection" v-if="node.question.max_selections === 1">
        <v-radio
          class="option"
          v-for="option in node.question.options"
          :key="option.id"
          :value="option.id">
            <div slot="label" class="label">
              <img v-if="option.image != null" :src="option.image"
                :alt="option.label" class="option-image" />
              <span>{{option.label}}</span>
            </div>
          </v-radio>
      </v-radio-group>
      <div v-else>
        <v-checkbox
          class="multiple-option"
          v-for="option in node.question.options"
          :key="option.id"
          hide-details
          :disabled="!checkSelectionLimits(option.id)"
          v-model="selectionList"
          :value="option.id">
          <div slot="label" class="label">
            <img v-if="option.image != null" :src="option.image"
              :alt="option.label" class="option-image" />
            <span>{{option.label}}</span>
          </div>
        </v-checkbox>
      </div>
    </div>
    <div v-else class="hotspot" v-html="hotspotSVG" @click="onHotspot">

    </div>
  </div>
  <div class="buttons">
    <v-btn
      class="submit-button"
      :disabled="!isValidSelection()"
      color="primary"
      @click="onAnswerQuestion">
      {{ submitButton }}
    </v-btn>
    <v-btn
      v-if="node.skippable"
      class="submit-button"
      color="secondary"
      @click="onSkipQuestion">
      {{ skipButton }}
    </v-btn>
  </div>
</div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'MultipleChoiceQuestion',
  data() {
    const options = {};
    const labels = {};

    this.node.question.options.forEach((item) => {
      options[item.id] = item;
      labels[item.label] = item;
    });

    return {
      selection: null,
      selectionList: [],
      previousHotspot: null,
      options,
      labels,
      hotspotSVG: null,
    };
  },
  mounted() {
    if (this.node.question.hotspot_svg) {
      axios.get(this.node.question.hotspot_svg)
        .then((resp) => {
          this.hotspotSVG = resp.data;
        });
    }
  },
  methods: {
    isValidSelection() {
      if (this.node.question.max_selections > 1) {
        if (this.selectionList.length >= this.node.question.min_selections) {
          return true;
        }
        return false;
      }
      if (this.selection !== null) {
        return true;
      }
      return false;
    },
    checkSelectionLimits(id) {
      if (this.node.question.max_selections > 1) {
        if (this.selectionList.length >= this.node.question.max_selections) {
          if (this.selectionList.includes(id)) {
            return true;
          }
          return false;
        }
        return true;
      }
      if (this.selectionList.includes(id)) {
        return true;
      }
      return this.selectionList.length === 0;
    },
    onHotspot(evt) {
      const label = evt.target.id;
      const el = evt.target;

      if (label in this.labels) {
        const { id } = this.labels[label];
        if (this.checkSelectionLimits(id)) {
          if (this.node.question.max_selections > 1) {
            if (this.selectionList.includes(id)) {
              this.selectionList.splice(this.selectionList.indexOf(id), 1);
              el.style.fill = null;
            } else {
              this.selectionList.push(id);
              el.style.fill = this.node.question.hotspot_selected_color;
            }
          } else {
            if (this.previousHotspot !== null) {
              this.previousHotspot.style.fill = null;
            }
            el.style.fill = this.node.question.hotspot_selected_color;
            this.selection = id;
            this.previousHotspot = el;
          }
        }
      }
    },
    onAnswerQuestion() {
      let id;
      let value;
      let values;
      let text;

      if (this.node.question.max_selections > 1) {
        id = this.selectionList;
        text = this.selectionList.map((i) => (this.options[i].label)).join('|');
        values = this.selectionList.map((i) => (this.options[i].value)).join('|');
        this.$emit('answer', {
          id,
          text,
          values,
          node: this.node,
        });
      } else {
        id = this.selection;
        value = this.options[id].value;
        text = this.options[id].label;
        this.$emit('answer', {
          id,
          value,
          text,
          node: this.node,
        });
      }

      this.selection = null;
      this.selectionList = [];
    },
    onSkipQuestion() {
      this.$emit('skip');
      this.selection = null;
      this.selectionList = [];
    },
    getOptionValue(id) {
      const option = this.node.question.options.find((item) => item.id === id);
      if (option !== undefined) {
        return option.value;
      }
      return null;
    },
  },
  props: {
    node: Object,
    submitButton: String,
    skipButton: String,
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.mc-question {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;

  .hotspot {
    width: 100%;
    svg {
      width: 100%;
    }
  }

  .question-image {
    display: block;
    max-width: 340px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
  }

  .option {
    padding-bottom: 0.5rem;

    .label {
      display: flex;
      flex-direction: row;
      align-items: center;
      img {
        max-height: 60px;
        margin-right: 1rem;
      }
    }
  }

  .multiple-option {
    padding-top: 0rem;
    padding-bottom: 0.5rem;

    .v-messages {
      display: none;
    }

    .label {
      display: flex;
      flex-direction: row;
      align-items: center;
      img {
        max-height: 60px;
        margin-right: 1rem;
      }
    }
  }

  .buttons {
    display: flex;
    width: 100%;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-self: center;
  }
}

@media (min-width: $breakpoint-tablet) {
  .mc-question {
    justify-content: flex-start;

    .buttons {
      margin-top: 3rem;
    }
  }
}
</style>
